import { useTranslation } from 'react-i18next'

import { formatNumbers } from 'lib/Helper'
import chartColors from 'assets/styles/scss/shared/_chart-colors.module.scss'
import bubbleChartstyles from 'components/Shared/Charts/ChartTooltip/ChartTooltip.module.scss'

export const CustomTooltip = (props: any) => {
  const { active, payload, title } = props
  const { t } = useTranslation()
  const {
    tooltipBody,
    tooltipTitle,
    flexContainer,
    legendDot,
    tooltipContent,
  } = bubbleChartstyles
  if (active && payload && payload.length) {
    const { count, name } = props?.payload?.[0]?.payload || {}
    const formattedcount = formatNumbers(count)
    const formattedText = t(
      `reporting.overview.contribution${count === 1 ? 'One' : 'Other'}`,
    )
    return (
      <div className={tooltipBody} data-testid="horizontal-barchart-tooltip">
        <div className={tooltipTitle}>{title}</div>
        <div className={flexContainer} key={name}>
          <div
            style={{
              backgroundColor: chartColors.iris,
            }}
            className={legendDot}
          ></div>
          <div className={tooltipContent}>
            {`${name}: `} {`${formattedcount} ${formattedText}`}
          </div>
        </div>
      </div>
    )
  }

  return null
}
